<script setup>
import { QrCodeIcon } from "@heroicons/vue/24/outline";
import LoadingSpinner from "../common/LoadingSpinner.vue";

// Props & Emits
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["click"]);
</script>

<template>
  <button
    @click="emit('click')"
    :disabled="disabled || loading"
    class="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 px-6 rounded-lg font-semibold text-lg hover:from-blue-700 hover:to-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105 active:scale-95"
  >
    <span v-if="loading" class="flex items-center justify-center">
      <LoadingSpinner size="sm" class="mr-2" />
      Generating...
    </span>
    <span v-else class="flex items-center justify-center">
      <QrCodeIcon class="w-6 h-6 mr-2" />
      Generate QR Code
    </span>
  </button>
</template>